import React, { createContext, useContext, useState, useEffect } from 'react';

// Crear el contexto
const XSignConnectionContext = createContext({
    isConnected: false,
    setIsConnected: () => { },
});

// Hook para usar el contexto
export const useXSignConnection = () => useContext(XSignConnectionContext);

// Proveedor del contexto
export const XSignConnectionProvider = ({ children }) => {
    const [isConnected, setIsConnected] = useState(false);

    // Log para depurar cambios en el estado
    useEffect(() => {
    }, [isConnected]);

    return (
        <XSignConnectionContext.Provider value={{ isConnected, setIsConnected }}>
            {children}
        </XSignConnectionContext.Provider>
    );
};